import {
  Cpu,
  ShieldAlert,
  LayoutDashboard,
  FileBarChart,
  Store,
  Boxes,
  Plug,
  Server,
  User,
  Building2,
} from "lucide-react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import "./AlgoTradingPage.css";

const INDIVIDUAL = [
  {
    icon: Cpu,
    title: "Managed Strategies",
    desc: "Rules-based, backtested strategies aligned to your risk appetite — systematic execution without emotional timing.",
  },
  {
    icon: ShieldAlert,
    title: "Risk Management",
    desc: "Position limits, drawdown controls, and stop frameworks designed to protect capital through volatile markets.",
  },
  {
    icon: LayoutDashboard,
    title: "Dashboard",
    desc: "Track live positions, strategy status, and performance metrics in a clear investor dashboard.",
  },
  {
    icon: FileBarChart,
    title: "Reports",
    desc: "Periodic performance and risk reports so you understand returns, exposure, and strategy behaviour.",
  },
];

const BROKERS = [
  {
    icon: Store,
    title: "White Label Solutions",
    desc: "Brandable algo platforms for brokers who want to offer systematic products under their own identity.",
  },
  {
    icon: Boxes,
    title: "Strategy Marketplace",
    desc: "Curate and distribute strategies to your client base with governance and reporting layers.",
  },
  {
    icon: Plug,
    title: "API Integration",
    desc: "Connect OMS, RMS, and client systems via APIs for seamless onboarding and order flow.",
  },
  {
    icon: Server,
    title: "Backend Support",
    desc: "Infrastructure, monitoring, and operational support so your desk focuses on clients — not servers.",
  },
];

export default function AlgoTradingPage() {
  return (
    <div className="algo-page">
      <PageHero
        badge="Algo Trading"
        title="Systematic strategies for investors & brokers"
        subtitle="Managed rules-based investing for individuals, and white-label algo infrastructure for brokerages across India."
        actions={[
          { label: "Book Free Consultation", to: "/contact", primary: true },
          { label: "Talk to an Expert", to: "/contact" },
        ]}
      />

      <section className="pm-section algo-pillar">
        <div className="pm-container">
          <div className="algo-pillar__head">
            <span className="pm-badge">
              <span className="pm-badge-dot" />
              <User size={12} />
              For Individual Investors
            </span>
            <h2 className="pm-section-title">Invest with process, not impulse</h2>
            <p className="pm-section-sub">
              Managed strategies, risk controls, dashboards, and transparent
              reporting.
            </p>
          </div>
          <div className="algo-grid">
            {INDIVIDUAL.map((item) => {
              const Icon = item.icon;
              return (
                <article key={item.title} className="pm-card algo-card">
                  <div className="algo-card__icon">
                    <Icon size={22} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="pm-section algo-pillar algo-pillar--brokers">
        <div className="pm-container">
          <div className="algo-pillar__head">
            <span className="pm-badge">
              <span className="pm-badge-dot" />
              <Building2 size={12} />
              For Brokers
            </span>
            <h2 className="pm-section-title">White-label algo infrastructure</h2>
            <p className="pm-section-sub">
              Marketplace, APIs, and backend support to scale systematic products
              for your clients.
            </p>
          </div>
          <div className="algo-grid">
            {BROKERS.map((item) => {
              const Icon = item.icon;
              return (
                <article key={item.title} className="pm-card algo-card">
                  <div className="algo-card__icon">
                    <Icon size={22} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBand
        title="Explore algo strategies or partner with us"
        subtitle="Whether you're an investor or a brokerage — let's discuss the right systematic setup."
        primary={{ label: "Book Free Consultation", to: "/contact" }}
        secondary={{ label: "Talk to an Expert", to: "/contact" }}
      />
    </div>
  );
}
